var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import {Component, Ref, Vue} from "vue-property-decorator";
import HeaderToolBar from "@/views/HeaderToolbar.vue";
import AccountForms from "@/views/components/AccountForms.vue";
import CompanyVerify from "@/views/components/CompanyVerify.vue";
import CompanyResult from "@/views/components/CompanyResult.vue";
import API from "@ym-framework/api-utils";
let Home = class extends Vue {
  constructor() {
    super(...arguments);
    this.checkTip = 1;
    this.loginStatus = "unlogin";
    this.verifyStatus = "waiting";
    this.companyInfo = "";
    this.failReason = "";
  }
  mounted() {
    return __async(this, null, function* () {
      yield this.certificationResults();
    });
  }
  certificationResults() {
    return __async(this, null, function* () {
      try {
        let token = localStorage.getItem("authenticationToken");
        if (!token) {
          return false;
        }
        let response = yield API.get(`api://base.auth/api/v6/certification`);
        this.loginStatus = "login";
        switch (response.data.status) {
          case 0:
            this.verifyStatus = "waiting";
            this.companyInfo = response.data.enterprise_name;
            this.checkTip = 3;
            break;
          case 1:
            this.verifyStatus = "success";
            this.companyInfo = response.data.enterprise_name;
            this.checkTip = 3;
            break;
          case 2:
            this.verifyStatus = "fail";
            this.companyInfo = response.data.enterprise_name;
            this.failReason = response.data.reason;
            this.checkTip = 3;
            break;
          default:
            break;
        }
      } catch (error) {
        if (error.status === 401) {
          this.loginStatus = "unlogin";
          localStorage.removeItem("authenticationToken");
          localStorage.removeItem("userName");
          return;
        }
        if (error.hasOwnProperty("response")) {
          if (error.response.data.errors.datas[0].code === "certification.select.error") {
            this.loginStatus = "login";
            this.checkTip = 2;
            return;
          }
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  ChangeVerify() {
    this.checkTip = 2;
  }
  ChangeResult() {
    return __async(this, null, function* () {
      yield this.certificationResults();
    });
  }
  ChangeLogin() {
    return __async(this, null, function* () {
      this.header_tool.checkName();
      yield this.certificationResults();
    });
  }
  toLogout() {
    return __async(this, null, function* () {
      this.loginStatus = "unlogin";
      this.checkTip = 1;
    });
  }
  checkTips(tip) {
    if (tip === this.checkTip) {
      return "active";
    } else if (tip > this.checkTip) {
      return "";
    } else if (tip < this.checkTip) {
      return "success";
    }
  }
};
__decorateClass([
  Ref("headersTool")
], Home.prototype, "header_tool", 2);
Home = __decorateClass([
  Component({
    components: {
      HeaderToolBar,
      AccountForms,
      CompanyVerify,
      CompanyResult
    }
  })
], Home);
export default Home;
